import { useEffect } from "react";
import { Routes, Route, Navigate, Outlet, useLocation } from "react-router-dom";

import { AppLayout, EmpresaLayout } from "./layouts";
import { NotFoundPage } from "./pages";
import { EncargadosTable, EstablecimientosTable } from "./tables";
import { ContactosTables } from "./tables/contactos-tables";
import { ActividadEconomicaTables } from "./tables/actividad-economica-tables";

import {
  ActividadEconomicaForm,
  AfiliacionForm,
  ArchivosAdjuntosForm,
  CelularForm,
  CorreoElectronicoForm,
  EmpresaForm,
  EncargadoForm,
  EstablecimientoForm,
  ExportacionForm,
  ImportacionForm,
  PaginaWebForm,
  TelefonoForm,
} from "./forms";

export function App() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Routes>
      <Route path="/" element={<AppLayout />}>
        <Route index element={<Navigate to="empresa" replace />} />

        <Route path="empresa" element={<EmpresaLayout />}>
          <Route index element={<Navigate to="datos-generales" replace />} />

          <Route path="datos-generales" element={<EmpresaForm />} />

          <Route path="establecimientos" element={<Outlet />}>
            <Route index element={<EstablecimientosTable />} />
            <Route path="add" element={<EstablecimientoForm />} />
            <Route path=":index/edit" element={<EstablecimientoForm />} />
          </Route>

          <Route path="contactos" element={<Outlet />}>
            <Route index element={<ContactosTables />} />

            <Route path="telefonos" element={<Outlet />}>
              <Route index element={<Navigate to="add" />} />
              <Route path="add" element={<TelefonoForm />} />
              <Route path=":index/edit" element={<TelefonoForm />} />
            </Route>

            <Route path="celulares" element={<Outlet />}>
              <Route index element={<Navigate to="add" />} />
              <Route path="add" element={<CelularForm />} />
              <Route path=":index/edit" element={<CelularForm />} />
            </Route>

            <Route path="correos-electronicos" element={<Outlet />}>
              <Route index element={<Navigate to="add" />} />
              <Route path="add" element={<CorreoElectronicoForm />} />
              <Route path=":index/edit" element={<CorreoElectronicoForm />} />
            </Route>

            <Route path="paginas-web" element={<Outlet />}>
              <Route index element={<Navigate to="add" />} />
              <Route path="add" element={<PaginaWebForm />} />
              <Route path=":index/edit" element={<PaginaWebForm />} />
            </Route>
          </Route>

          <Route path="encargados" element={<Outlet />}>
            <Route index element={<EncargadosTable />} />
            <Route path="add" element={<EncargadoForm />} />
            <Route path=":index/edit" element={<EncargadoForm />} />
          </Route>

          <Route path="actividad-economica" element={<Outlet />}>
            <Route index element={<ActividadEconomicaTables />} />

            <Route path="actividades-economicas">
              <Route index element={<Navigate to="add" />} />
              <Route path="add" element={<ActividadEconomicaForm />} />
              <Route path=":index/edit" element={<ActividadEconomicaForm />} />
            </Route>

            <Route path="exportaciones" element={<Outlet />}>
              <Route index element={<Navigate to="add" />} />
              <Route path="add" element={<ExportacionForm />} />
              <Route path=":index/edit" element={<ExportacionForm />} />
            </Route>

            <Route path="importaciones" element={<Outlet />}>
              <Route index element={<Navigate to="add" />} />
              <Route path="add" element={<ImportacionForm />} />
              <Route path=":index/edit" element={<ImportacionForm />} />
            </Route>
          </Route>

          <Route path="afiliacion" element={<AfiliacionForm />} />

          <Route path="archivos-adjuntos" element={<ArchivosAdjuntosForm />} />
        </Route>

        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
